import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'providers/AuthProvider';

interface PublicOnlyRouteProps {
  children: ReactNode;
  redirectPath?: string;
}

const PublicOnlyRoute = ({
  children,
  redirectPath = '/dashboard'
}: PublicOnlyRouteProps) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

export default PublicOnlyRoute;
